module.exports = __webpack_public_path__ + "img/bg-pc.3d23cf35.jpg";